(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-cro"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-collection-prducts"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function multipleCollectiontab() {
      const button_tabs = document.querySelectorAll('.button--tabs');
      if (!button_tabs.length) return;

      button_tabs.forEach(function (tabButton) {
        tabButton.addEventListener('click', function () {
          const wrapper = this.closest('.tabs-container');
          const button_content = wrapper.querySelectorAll('.tabs-content-hidden');
          const button_tab = wrapper.querySelectorAll('.button--tabs');
          const target_id = this.getAttribute('data-id');
          button_tab.forEach((item) => item.classList.remove('is_active'));
          button_tab.forEach(t => t.setAttribute('aria-selected','false'));
          this.setAttribute('aria-selected','true');
          this.classList.add('is_active');
          button_content.forEach((item) => item.classList.remove('is-active'));
          const activeTab = document.querySelector('#' + target_id);
          activeTab.classList.add('is-active');
          animateCards(activeTab);
        });
      });
    }
    function animateCards(container) {
      const cards = container.querySelectorAll('.product-grid--item');
      cards.forEach((card, index) => {
        card.classList.remove('animate-in');
        void card.offsetWidth;
        setTimeout(() => {
          card.classList.add('animate-in');
        }, index * 200);
      });
    }
    const firstActiveTab = document.querySelector('.tabs-content-hidden.is-active');
    if (firstActiveTab) {
      animateCards(firstActiveTab);
    }
    multipleCollectiontab();
  });

  } catch(e) { console.error(e); }
})();
})();
